import { FlexColumn, FlexRow, LabeledInput, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useEffect, useMemo, useState } from 'react';
import { FEEDBACK, FEEDBACK_PREFIXES } from '../../constants/app';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { postSubBrand } from '../../services/vehicleService';
import { SubBrand } from '../../types/subBrand';
import StyledTooltip from '../ui/StyledTooltip';

type Props = {
  onCancel: () => void;
  afterSave: () => void;
  brandId?: string;
};
export function SubBrandForm({ onCancel, afterSave, brandId }: Props) {
  const { css } = useStyles();
  const [editingSubBrand, setEditingSubBrand] = useState<SubBrand>({
    _id: '',
    name: '',
    brand: {
      _id: '',
      name: '',
    },
  });
  const { startLoading, stopLoading, loading } = useLoading(false);
  const { showFailFeedback, showPositiveFeedback } = useFeedback();
  const [selectedBrandId, setSelectedBrandId] = useState<string>();

  const canSubmit = useMemo(() => {
    return !!editingSubBrand.name && !!editingSubBrand.brand._id;
  }, [editingSubBrand]);

  const onInputChange = (value: string | undefined | null | {}, field: keyof SubBrand) => {
    setEditingSubBrand((prev) => ({ ...prev!, [field]: value }));
  };

  useEffect(() => {
    if (!brandId && !selectedBrandId) return;
    setSelectedBrandId(brandId);
    onInputChange({ _id: brandId }, 'brand');
  }, [brandId]);

  const onSave = async () => {
    startLoading();
    const { id, error } = await postSubBrand(editingSubBrand);
    if (!error && id) {
      afterSave();
      showPositiveFeedback(FEEDBACK.created(FEEDBACK_PREFIXES.subBrand));
    } else {
      showFailFeedback(error || FEEDBACK.failedCreation(FEEDBACK_PREFIXES.subBrand));
    }
    stopLoading();
  };

  return (
    <FlexColumn
      classNames={css({
        justifyContent: 'space-between',
        overflow: 'hidden',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'end',
      })}
    >
      <FlexColumn
        classNames={css({
          overflow: 'auto',
          width: '100%',
          height: '100%',
          flexDirection: 'row',
        })}
      >
        <LabeledInput
          label={`(Nueva Submarca) Nombre:`}
          value={editingSubBrand?.name}
          onChange={(value) => onInputChange(value, 'name')}
          required
        />
      </FlexColumn>
      <FlexRow gap={0}>
        <StyledTooltip
          content={'Cancelar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onCancel}
            kind="tertiary"
          >
            <MaterialIcon name={'cancel'} />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content={'Guardar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onSave}
            isLoading={loading}
            disabled={!canSubmit}
            kind="tertiary"
          >
            <MaterialIcon name={'done'} />
          </Button>
        </StyledTooltip>
      </FlexRow>
    </FlexColumn>
  );
}
